import { motion } from "framer-motion";

const phases = [
    {
        n: "Phase 01",
        title: "Build",
        span: "Weeks 1–4",
        bullets: [
            "ICP & offer lock-in",
            "Website, GMB, pixels, Google Tags",
            "Clay + LeadMagic + Instantly + RB2B wired",
            "Domains warmed. Creative shipped. Both engines live by Week 4.",
        ],
    },
    {
        n: "Phase 02",
        title: "Test",
        span: "Weeks 5–8",
        bullets: [
            "Meta creative rotations against inbound intent",
            "Outbound sequence A/Bs on angle + persona",
            "Shared exclusion list. Shared definition of qualified.",
            "First cohort of meetings converting to opportunity.",
        ],
    },
    {
        n: "Phase 03",
        title: "Scale",
        span: "Weeks 9–12",
        bullets: [
            "Winning creative fed into outbound. Winning cold hooks fed into ads.",
            "Cost per meeting drops 40–60% by Month 3.",
            "Steady-state: 30 qualified meetings per month.",
            "One dashboard. One leader. One clock.",
        ],
    },
];

export default function Playbook() {
    return (
        <section
            id="playbook"
            data-testid="playbook-section"
            className="container-x py-24 md:py-40"
        >
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
                className="max-w-3xl mb-16"
            >
                <span className="tag">The 90-Day Playbook</span>
                <h2 className="font-display uppercase text-white text-5xl md:text-7xl mt-4 leading-[0.9]">
                    Build.&nbsp;
                    <span className="font-editorial italic font-normal normal-case text-[#e84125] tracking-normal">
                        Test.&nbsp;
                    </span>
                    Scale.
                </h2>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border border-white/10">
                {phases.map((p, i) => (
                    <motion.div
                        key={p.n}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: i * 0.14, duration: 0.7 }}
                        data-testid={`playbook-${p.title.toLowerCase()}`}
                        className={`p-8 md:p-10 flex flex-col gap-6 ${
                            i < phases.length - 1
                                ? "md:border-r border-white/10 border-b md:border-b-0"
                                : ""
                        } ${i === 1 ? "bg-[#0c0c0c]" : ""}`}
                    >
                        <div className="flex items-baseline justify-between">
                            <span className="font-mono uppercase text-[0.7rem] tracking-[0.22em] text-white/40">
                                {p.n}
                            </span>
                            <span className="font-mono uppercase text-[0.7rem] tracking-[0.22em] text-[#e84125]">
                                {p.span}
                            </span>
                        </div>
                        <h3 className="font-display uppercase text-white text-5xl md:text-6xl leading-none">
                            {p.title}
                        </h3>
                        <ul className="ruled">
                            {p.bullets.map((b, k) => (
                                <li
                                    key={k}
                                    className="py-3 font-body text-white/70 text-sm md:text-base leading-relaxed flex gap-3"
                                >
                                    <span className="font-mono text-[#e84125] mt-1 text-xs">
                                        {String(k + 1).padStart(2, "0")}
                                    </span>
                                    <span>{b}</span>
                                </li>
                            ))}
                        </ul>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
